import PropTypes from "prop-types";
import { useContext } from "react";
import Fade from "react-bootstrap/Fade";
import { RenderWhen } from "../../../components";
import { RlNavContext } from "./RlNav";

const RlNavItems = ({ children }) => {
  const { toggleExpand, expanded } = useContext(RlNavContext);

  return (
    <section
      id="left-column"
      className={"rlbs sample-details-sidebar__container"}
    >
      <div className="sample-details-sidebar__toggle-container">
        <div
          className="sample-details-sidebar__toggle"
          onClick={toggleExpand}
          aria-controls="example-collapse-text"
          aria-expanded={expanded}
        >
          <RenderWhen condition={expanded}>
            <span className="sample-details-sidebar__toggle-text">
              Hide Panel
            </span>
          </RenderWhen>
          <span className="sample-details-sidebar__toggle-icon"></span>
        </div>
      </div>
      <Fade in={expanded} timeout={150}>
        <div className="rl-nav">{children}</div>
      </Fade>
    </section>
  );
};

RlNavItems.propTypes = {
  children: PropTypes.node
};
export default RlNavItems;
